<template>
  <div class="bg-nav">
    <!-- NAVBAR -->
    <div>
      <Navbar />
    </div>
    <div v-if="banner?.status" class="backtest w-full mt-12">
      <div class="lg:bg-banner-cot sm:bg-banner-cot-res">
        <!-- BANNER -->
        <div
          class="grid grid-cols-3 gap-4 container rounded-2xl bg-banner h-96 sm:h-80"
        >
          <div class="col-span-3 sm:col-span-2 p-2 sm:p-2 m-auto">
            <h1
              class="font-semibold text-3xl text-theme-4 text-center sm:text-left font-crimson_pro"
            >
              {{ banner.title }}
            </h1>
            <p
              class="font-normal text-base my-2 text-center sm:text-left font-poppins"
            >
              {{ banner.description }}
            </p>
            <div class="text-center sm:text-left pt-2 sm:pt-0">
              <button
                class="m-auto sm:m-0 h-12 rounded text-white hover:scale-110 btn-deg font-poppins"
                @click="setFilterCategory(banner.category_id)"
              >
                Ver productos
              </button>
            </div>
          </div>
          <div class="col-span-3 sm:col-span-1 p-2 sm:p-2 m-auto">
            <img
              :src="banner.image[0]"
              alt="imagen del banner"
              class="h-28 sm:h-48 object-contain object-center w-full"
              crossorigin="anonymous"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <template v-if="catalogueData">
    <div
      class="flex flex-row bg-products-cot container !h-auto mt-20 md:mt-0 mb-12"
    >
      <div class="hidden md:flex flex-col w-1/4">
        <div class="flex flex-row justify-between">
          <p class="font-bold ml-4">Filtros</p>
          <button
            type="button"
            class="rounded-full border border-[#6A040F] px-2 hover:bg-gradient-to-r hover:from-[#e85c04] hover:to-[#faa306] hover:bg-clip-text hover:text-transparent hover:font-bold transition-all duration-75 ease-in-out"
            @click="clearFilters"
          >
            Limpiar filtros
          </button>
        </div>
        <hr class="w-full" />
        <AccordionCategories
          :filters="catalogueData"
          type="web"
          v-model:is-mobile="isMobile"
        />
      </div>
      <div class="flex flex-col w-full md:w-0 md:flex-grow mx-auto">
        <div class="flex flex-col md:flex-row justify-between my-2">
          <div class="flex w-full md:w-1/3">
            <section class="intro sm:w-3/4 w-full">
              <div class="input-group input-group-lg">
                <span class="input-group-text px-1 i-search" id="basic-addon2">
                  <SearchIcon />
                </span>
                <input
                  v-model="searchText"
                  type="text"
                  class="form-control form-control-lg i-search-form"
                />
              </div>
            </section>
          </div>
          <div class="hidden md:flex items-center w-1/3">
            <DropdownCatalogue v-model:orderBy="orderBy" />
          </div>
          <div class="flex container md:hidden flex-row mt-1">
            <div
              class="flex justify-center items-center w-1/2 border border-black p-1"
            >
              <DropdownCatalogue v-model:orderBy="orderBy" />
            </div>
            <div
              class="flex items-center justify-center w-1/2 border border-black p-1"
            >
              <button
                class="flex w-full items-center justify-center"
                @click="filtersOpen"
              >
                <SlidersIcon class="rotate-90" />
                <p>Filtros</p>
              </button>
            </div>
          </div>
        </div>
        <div class="flex flex-row flex-wrap gap-4" v-if="productsData">
          <div
            class="b-cot-card min-h-[288px] p-4 sm:max-w-[192px] md:max-w-[296px] w-full cursor-pointer"
            style="background-color: #f4f4f45c"
            v-for="product in productsData.data || []"
            :key="product"
            :title="product.name"
          >
            <div class="grid grid-cols-4 gap-4">
              <div class="col-span-3" @click="goToProduct(product)">
                <h1 class="text-theme-9 font-poppins font-medium truncate">
                  {{ product.name }}
                </h1>
              </div>
              <div>
                <span @click="changeFavoriteProduct(product)">
                  <heartIcon
                    :class="{
                      'text-transparent': !product?.users_favorite?.length,
                      'text-theme-9': product?.users_favorite?.length
                    }"
                    class="font-poppins font-medium fill-current"
                    :style="{
                      stroke: !product?.users_favorite?.length
                        ? '#a13122'
                        : 'currentColor'
                    }"
                  />
                </span>
              </div>
            </div>
            <div
              class="w-full md:w-44 h-40 mx-auto my-4"
              style="background: #ffffff7a; border-radius: 24px"
              @click="goToProduct(product)"
            >
              <img
                class="h-40 object-contain m-auto rounded-lg"
                alt="Imagen del producto"
                :src="getProductImage(product)"
                crossorigin="anonymous"
              />
            </div>
            <div
              class="grid grid-rows-2 md:grid-cols-2 md:gap-4"
              @click="goToProduct(product)"
            >
              <div class="text-xs font-poppins">
                Mínimo
                {{ product?.low_sale_volume_customization?.minimum_units || 0 }}
                pzas
              </div>
              <div class="text-xs font-poppins">
                <template v-if="!urlOriginIsBrandIn">
                  Desde
                  {{
                    formatter.format(
                      product?.low_customization?.base_price || 0
                    )
                  }}
                  MXN
                </template>
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex flex-row flex-wrap w-full justify-center items-center pt-1 px-2"
          v-if="productsData"
        >
          <div
            class="flex flex-row flex-grow max-w-1/2 sm:flex-grow-0 items-center pr-1 order-2 sm:order-1"
          >
            <p>Productos por página:</p>
            <select
              v-model="productsData.per_page"
              @change="changePerPage(productsData.per_page)"
            >
              <option
                v-for="(size, index) in pageSize"
                :key="index"
                :value="size"
                class="text-center"
              >
                {{ size }}
              </option>
            </select>
          </div>
          <div
            class="flex w-full md:w-0 flex-row sm:flex-grow md:max-w-1/3 items-center justify-center order-1 sm:order-2"
          >
            <button
              class="h-8 w-8 border border-theme-13 text-theme-13 rounded-lg flex justify-center items-center disabled:cursor-not-allowed"
              :disabled="paginate.current_page === 1"
              @click="changePage(paginate.current_page - 1)"
            >
              <ArrowLeftIcon />
            </button>
            <button
              class="h-8 w-8 text-theme-13 text-xl hover:font-bold flex justify-center items-center"
              v-if="paginate.current_page - 1"
              @click="changePage(paginate.current_page - 1)"
            >
              {{ paginate.current_page - 1 }}
            </button>
            <button
              class="h-8 w-8 text-theme-13 text-xl font-bold flex justify-center items-center"
            >
              {{ paginate.current_page }}
            </button>
            <button
              class="h-8 w-8 text-theme-13 text-xl hover:font-bold flex justify-center items-center"
              v-if="paginate.current_page + 1 <= paginate.last_page"
              @click="changePage(paginate.current_page + 1)"
            >
              {{ paginate.current_page + 1 }}
            </button>
            <button
              class="h-8 w-8 border border-theme-13 text-theme-13 rounded-lg flex justify-center items-center disabled:cursor-not-allowed"
              :disabled="paginate.current_page === paginate.last_page"
              @click="changePage(paginate.current_page + 1)"
            >
              <ArrowRightIcon />
            </button>
          </div>
          <div
            class="flex flex-wrap md:flex-nowrap flex-row flex-grow max-w-1/2 sm:flex-grow-0 items-center space-x-1 order-3"
          >
            <p class="w-full text-center md:text-left md:w-auto">Mostrando</p>
            <div class="w-full md:w-auto flex items-center justify-center">
              <p class="font-bold">{{ paginate.from }} - {{ paginate.to }}</p>
              <p class="px-1">de</p>
              <p class="font-bold">{{ paginate.total }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="fixed top-0 right-0 bottom-0 flex-col pt-6 pb-2 px-6 border-r hidden h-screen w-5/6 max-w-sm bg-white z-50"
        ref="filtersCatalogue"
      >
        <div class="flex justify-end">
          <p
            class="font-medium cursor-pointer hover:underline"
            @click="filtersOpen"
          >
            Cerrar
          </p>
        </div>
        <div class="flex flex-row justify-between mb-1">
          <p class="font-bold ml-4">Filtros</p>
          <button
            type="button"
            class="rounded-full border border-[#6A040F] px-2 hover:bg-gradient-to-r hover:from-[#e85c04] hover:to-[#faa306] hover:bg-clip-text hover:text-transparent hover:font-bold transition-all duration-75 ease-in-out"
            @click="clearFilters"
          >
            Limpiar filtros
          </button>
        </div>
        <hr class="w-full" />
        <div class="h-full overflow-x-auto">
          <AccordionCategories
            :filters="catalogueData"
            type="mobile"
            v-model:is-mobile="isMobile"
          />
        </div>
        <hr class="my-1" />
        <div class="flex justify-center items-center h-14">
          <button
            class="m-auto sm:m-0 h-12 rounded text-white hover:scale-110 btn-deg font-poppins"
            @click="handleOnSubmitFilter"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
    <div>
      <Footer />
    </div>
  </template>
</template>

<script>
import Navbar from '@/components/navbar/Main.vue'
import Footer from '@/components/footer/Main.vue'
import DropdownCatalogue from '@/components/dropdown-catalogue/Main.vue'
import AccordionCategories from '@/components/accordion-categories/Main.vue'
import { cleanSession, getFirstErrorMessage, formatter } from '@/utils/tools'
import { arrayMoveImmutable } from 'array-move'

export default {
  components: {
    Navbar,
    Footer,
    DropdownCatalogue,
    AccordionCategories
  },
  data() {
    return {
      formatter: formatter,
      catalogueData: undefined,
      banner: undefined,
      productsData: undefined,
      showTinySlider: true,
      isMobile: false,
      pageSize: [24, 36, 48],
      timer: null
    }
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    if (!isNaN(parseInt(this.$route.query.categoryId))) {
      this.$store.commit('catalogue/resetFilters')
      this.$store.commit('catalogue/resetPaginate')
      this.catalogueFilters = {
        ...this.catalogueFilters,
        productTypes: [parseInt(this.$route.query.categoryId)]
      }
    }

    if (!isNaN(parseInt(this.$route.query.sliderId))) {
      this.$store.commit('catalogue/resetFilters')
      this.$store.commit('catalogue/resetPaginate')
      this.catalogueFilters = {
        ...this.catalogueFilters,
        sliderId: parseInt(this.$route.query.sliderId)
      }
    }

    if (!isNaN(parseInt(this.$route.query.temporalityId))) {
      this.catalogueFilters = {
        ...this.catalogueFilters,
        categories: [
          ...this.catalogueFilters.categories,
          parseInt(this.$route.query.temporalityId)
        ]
      }
    }
    this.getCatalogueData()
    this.getBanner()
    this.getProductsData()
  },
  methods: {
    async getCatalogueData() {
      try {
        const response = await this.axios.get(
          'sales-operator/products/product-filters',
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.catalogueData = response.data || {
          categories: [],
          materials: [],
          colors: undefined,
          product_types: [],
          product_versions: [],
          price: undefined,
          min_delivery: 1,
          max_delivery: 100
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async getBanner() {
      try {
        const response = await this.axios.get(
          'common/banner-by-section/catalogue',
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.banner = response.data?.banner
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async getProductsData() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        this.productsData = undefined
        const params = {
          search: this.searchText || null,
          days_approx_delivery_until: this.catalogueFilters.time || null,
          price_until_min:
            this.catalogueFilters.price &&
            this.catalogueFilters.price.length > 1
              ? this.catalogueFilters.price[0] || null
              : null,
          price_until_max:
            this.catalogueFilters.price &&
            this.catalogueFilters.price.length > 1
              ? this.catalogueFilters.price[1] || null
              : null,
          page: this.paginate.current_page,
          per_page: this.paginate.per_page,
          slider_id: this.catalogueFilters.sliderId || null
        }
        if (this.catalogueFilters.categoryIdSelected) {
          params.category_id = this.catalogueFilters.categoryIdSelected
        }
        if (this.catalogueFilters.color) {
          params.colors = [this.catalogueFilters.color]
        }
        if (this.catalogueFilters.materials.length) {
          params.materials = this.catalogueFilters.materials
        }
        if (this.catalogueFilters.productTypes.length) {
          params.product_types = this.catalogueFilters.productTypes
        }
        if (this.catalogueFilters.productVersions.length) {
          params.product_versions = this.catalogueFilters.productVersions
        }
        if (this.catalogueFilters.categories.length) {
          params.categories = this.catalogueFilters.categories
        }
        switch (this.catalogueFilters.orderBy) {
          case 'createdAtDesc':
            params.order_type = 'created_at'
            params.order_sort = 'DESC'
            break
          case 'priceAsc':
            params.order_type = 'price'
            params.order_sort = 'ASC'
            break
          case 'priceDesc':
            params.order_type = 'price'
            params.order_sort = 'DESC'
            break
        }

        const response = await this.axios.get(
          '/sales-operator/products/products-by-search-specific',
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            },
            params
          }
        )

        const { from, to, total } = response.data?.products

        this.productsData = {
          ...response.data?.products,
          data: response?.data?.products?.data?.map((p) => ({
            ...p,
            salesvolume: p?.salesvolume?.sort(
              (a, b) => a.minimum_unit_sale - b.minimum_unit_sale
            )
          })),
          per_page: response.data?.products.per_page + 1
        }
        this.paginate = {
          ...this.paginate,
          current_page: response.data?.products.current_page,
          last_page: response.data?.products.last_page,
          from,
          to,
          total,
          per_page: response.data?.products.per_page + 1
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    setFilterCategory(categoryId) {
      if (this.catalogueFilters.categoryIdSelected !== categoryId) {
        this.showTinySlider = false
        this.catalogueFilters.categoryIdSelected = categoryId
        setTimeout(() => {
          this.showTinySlider = true
        })
      }
    },
    deepEqual(object1, object2) {
      const keys1 = Object.keys(object1)
      const keys2 = Object.keys(object2)
      if (keys1.length !== keys2.length) {
        return false
      }
      for (const key of keys1) {
        const val1 = object1[key]
        const val2 = object2[key]
        const areObjects = this.isObject(val1) && this.isObject(val2)
        if (
          (areObjects && !this.deepEqual(val1, val2)) ||
          (!areObjects && val1 !== val2)
        ) {
          return false
        }
      }
      return true
    },
    isObject(object) {
      return object != null && typeof object === 'object'
    },
    getProductImage(product) {
      return Array.isArray(product.image) && product.image.length
        ? product.image[0]
        : product.image !== null && !Array.isArray(product.image)
        ? product.image
        : require(product.sku !== 'COTESPI001'
            ? '@/assets/images/product.svg'
            : '@/assets/images/COTESPI001.svg')
    },
    async changeFavoriteProduct(product) {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.post(
          'sales-operator/favorite-products/edit-favorite-product',
          {
            product_id: product.id
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        await this.getProductsData()
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    goToProduct(product) {
      this.$router.push({ name: 'products', params: { id: product.id } })
    },
    filtersOpen() {
      const classList = this.$refs.filtersCatalogue.classList
      if (classList.contains('hidden')) {
        classList.remove('hidden')
        classList.add('flex')
      } else {
        classList.remove('flex')
        classList.add('hidden')
      }
    },
    async handleOnSubmitFilter() {
      this.$store.commit('main/setShowSpinner', true)
      this.$router.replace({ path: '/catalogue' })
      this.filtersOpen()
      this.$store.commit('main/setShowSpinner', false)
    },
    async changePage(page) {
      this.$store.commit('main/setShowSpinner', true)
      this.paginate = { ...this.paginate, current_page: page }
      await this.getProductsData()
      this.$store.commit('main/setShowSpinner', false)
    },
    async changePerPage(perPage) {
      this.$store.commit('main/setShowSpinner', true)
      this.paginate = { ...this.paginate, per_page: perPage }
      await this.getProductsData()
      this.$store.commit('main/setShowSpinner', false)
    },
    clearFilters() {
      this.$store.commit('catalogue/resetFilters')
      this.$store.commit('catalogue/resetPaginate')
      if (!this.isMobile) {
        this.$router.replace({ path: '/catalogue' })
      }
    }
  },
  computed: {
    urlOriginIsBrandIn() {
      return this.$store.getters['main/urlOriginIsBrandIn']
    },

    sliderCategories() {
      if (
        this.catalogueData?.categories &&
        this.catalogueFilters.categoryIdSelected
      ) {
        const index = this.catalogueData.categories.findIndex(
          (category) => category.id === this.catalogueFilters.categoryIdSelected
        )
        return arrayMoveImmutable(this.catalogueData.categories, index, 0)
      }
      return this.catalogueData?.categories || []
    },
    catalogueFilters: {
      get() {
        return this.$store.state.catalogue.filters
      },
      set(value) {
        this.$store.commit('catalogue/setFilters', value)
      }
    },
    searchText: {
      get() {
        return this.catalogueFilters.searchText
      },
      set(value) {
        this.catalogueFilters = {
          ...this.catalogueFilters,
          searchText: value
        }
      }
    },
    orderBy: {
      get() {
        return this.catalogueFilters.orderBy
      },
      set(value) {
        this.catalogueFilters = {
          ...this.catalogueFilters,
          orderBy: value
        }
      }
    },
    paginate: {
      get() {
        return this.$store.state.catalogue.paginate
      },
      set(value) {
        this.$store.commit('catalogue/setPaginate', value)
      }
    }
  },
  watch: {
    catalogueFilters: {
      async handler(val) {
        if (this.catalogueData) {
          const clone = structuredClone(val)
          if (this.timer) {
            clearTimeout(this.timer)
          }
          this.timer = setTimeout(async () => {
            if (
              (this.deepEqual(clone, this.catalogueFilters) &&
                !this.isMobile) ||
              this.searchText !== undefined
            ) {
              this.$store.commit('main/setShowSpinner', true)
              this.paginate = { ...this.paginate, current_page: 1 }
              await this.getProductsData()
              this.$store.commit('main/setShowSpinner', false)
            }
          }, 1300)
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
/* html {
  background: url(http://localhost:8080/img/COT-background.50df66c9.svg)
    no-repeat center center fixed;
  background-size: cover;
  background: #f1eae9;
}

body {
  background: #f1eae9;
} */

.bg-nav {
  background: url('@/assets/images/COT-bg/img-slider-nav.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 480px;
  width: auto;
}

.bg-banner-2 {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-geometria {
  background: url('@/assets/images/COT-bg/img-geometria.svg');
  background-repeat: no-repeat;
  background-position: center;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-cat-bg {
  background: url('@/assets/images/COT-bg/img-categorias.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 60px;
  width: auto;
  padding-top: 2px;
}

.bg-banner {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  backdrop-filter: blur(8px) brightness(100%);
  border: 3px solid rgba(255, 255, 255, 0.28);
}

.backtest {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-banner-cot {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 198px;
  width: auto;
  padding-top: 0px;
  margin-bottom: 18rem;
}

.bg-banner-cot-res {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 445px;
  width: auto;
  padding-top: 0px;
}

.bg-products-cot {
  background: url('@/assets/images/COT-bg/img-products.svg');
  background-repeat: no-repeat;
  background-position: inherit;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 230px;
  width: auto;
  padding-top: 2px;
}

.bg-help {
  background: url('@/assets/images/COT-bg/img-help.svg');
  background-repeat: no-repeat;
  background-position: right;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 350px;
  width: auto;
  padding-top: 2px;
}

.btn-deg {
  background: linear-gradient(89.75deg, #e85c04 0.17%, #faa306 99.78%);
  transition: 0.3s;
  outline: 1px solid transparent;
  width: 200px;
  font-weight: 600;
}

.text-deg {
  transition: 0.3s;
  outline: 1px solid transparent;
  width: 200px;
  font-weight: 600;
}

.b-cot-card {
  background-image: radial-gradient(
      circle at 100% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to right, #ffffff, #ffffff),
    radial-gradient(
      circle at 0% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to bottom, #ffffff, #f6f6e0),
    radial-gradient(
      circle at 0% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 21px
    ),
    linear-gradient(to left, #ffffff21, #ffffff21),
    radial-gradient(
      circle at 100% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 17px
    ),
    linear-gradient(to top, #ffffff21, #ffffff);
  background-size: 21px 21px, calc(100% - 42px) 3px, 21px 21px,
    3px calc(100% - 42px);
  background-position: top left, top center, top right, center right,
    bottom right, bottom center, bottom left, center left;
  background-repeat: no-repeat;
  border-radius: 24px;
}

.bg-card {
  background: #ffffff21;
  border-radius: 24px;
}

.eventos {
  background-image: url('@/assets/images/COT-img/eventos/fiestas-1.svg');
}

.flip-card {
  background-color: transparent;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  /* Note: backdrop-filter has minimal browser support */
  border-radius: 20px;
}

.flip-card-back {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  border-radius: 20px;
  transform: rotateY(180deg);
}

.brandin-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
}

/* SEARCH CONTROL CSS */
.form-control {
  border-color: transparent;
}

.input-group > .form-control:focus {
  box-shadow: inset 0 0 0 1px transparent;
}
.btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active,
.btn-link.active {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:focus,
.btn-link.focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.btn-link:active:focus,
.btn-link.active:focus {
  background-color: rgba(0, 0, 0, 0.05);
}

.i-search {
  border-radius: 6px 0px 0px 6px !important;
  background: rgb(241, 241, 241) !important;
  border-color: #cacaca !important;
  border-bottom-width: 1px !important;
  border-style: solid none solid solid !important;
  border-top-width: 1px !important;
  border-left-width: 1px !important;
  border-right-width: initial !important;
}
.i-search-form {
  background: rgb(241, 241, 241);
  border-color: #cacaca;
  border-bottom-width: 1px;
  border-style: solid solid solid none;
  border-top-width: 1px;
  border-right-width: 1px;
  border-left-width: initial;
  border-radius: 0px 6px 6px 0px;
  box-shadow: 0 0 0;
}

@media (width >=768px) {
  .md\:max-w-1\/3 {
    max-width: 33.333333%;
  }
}
</style>
